import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "common/config/auth.config";

export async function getToken() {
  const request = {
    scopes: [process.env.REACT_APP_API_SCOPE || ""]
  };
  // let tokenResult;
  // try {
  //   tokenResult = await msalInstance.acquireTokenSilent(request);
  // } catch (error: any) {
  //   if (error instanceof InteractionRequiredAuthError) {
  //     // Prompt the user for consent interactively
  //     tokenResult = await msalInstance.acquireTokenPopup(request);
  //   } else {
  //     throw error;
  //   }
  // }
  // return `Bearer ${tokenResult.accessToken}`;
}
